// The look-alike counter from /api/data/census: official Stock Tokens, tokens whose symbol looks like
// one, and the pools that hold a look-alike. Counts cover what the indexer has scanned, which is why
// the census's own coverage note travels with the figures.
import type { CensusPayload } from '../api/types';
import { fmtUtc, parseTs } from './format';

export interface CensusFigures {
  official: string;
  lookalike: string;
  pools: string;
  /** "734 pools and 404 tokens indexed, 2026-09-12 12:04 UTC" */
  sub: string;
  /** The coverage note of the payload, verbatim. */
  note: string;
}

const count = (v: number | null | undefined): string =>
  typeof v === 'number' && Number.isFinite(v) ? v.toLocaleString('en-US') : 'n/a';

export function censusFigures(p: CensusPayload): CensusFigures {
  const at = parseTs(p.as_of);
  return {
    official: count(p.tokens.official),
    lookalike: count(typeof p.impostor_total === 'number' ? p.impostor_total : p.tokens.impostor),
    pools: count(p.pools.by_official.impostor),
    sub: `${count(p.pools.total)} pools and ${count(p.tokens.total)} tokens indexed, ${at ? fmtUtc(at) : 'time n/a'}`,
    note: p.coverage.note,
  };
}
